import 'library/styles/global/rotate.scss';
import 'apps/survey/styles/components/versions/list.scss';
import PropTypes from 'prop-types';
import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import AdjectiveRow from 'apps/survey/components/versions/list/adjective-row';
import RealInstructions from 'apps/survey/components/versions/list/real-instructions';
import IdealInstructions from 'apps/survey/components/versions/list/ideal-instructions';
import SavingButton from 'library/components/saving-button';
import ScrollAnimation from 'library/util/scroll';
import { submitButtonSurvey, nextButtonSurvey } from 'apps/survey/services/label-instructions';

class ListVersion extends React.Component {
  static propTypes = {
    adjectives: PropTypes.array,
    responses: PropTypes.object,
    onChange: PropTypes.func,
    state: PropTypes.oneOf(['ideal', 'real']),
    onComplete: PropTypes.func
  }

  state = {
    showModal: {
      real: false,
      ideal: false
    },
    saving: false,
    modalShown: false
  }

  constructor(...params) {
    super(...params);
    this.ref = React.createRef();
    this.firstReal = React.createRef();
    this.firstIdeal = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.showModalOnFocus);
    this.showModalOnFocus();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.showModalOnFocus);
  }

  _focusTimeout = null

  showModalOnFocus = () => {
    clearTimeout(this._focusTimeout);
    this._focusTimeout = setTimeout(this.checkAndShowModal, 100);
  }

  checkAndShowModal = async () => {
    if (this.ref && this.ref.current) {
      if (this.ref.current.offsetTop - window.pageYOffset < 100) {
        window.removeEventListener('scroll', this.showModalOnFocus);
        if (this.ref.current.offsetTop - window.pageYOffset > 0) {
          await new Promise((resolve)=>{
            new ScrollAnimation(window.pageYOffset, this.ref.current.offsetTop, 100, 'easeInOutQuad', window, resolve);
          });
        }

        this.showModal();
      }
    }
  }

  showModal = () => {
    this.setState({
      showModal: {
        real: true,
        ideal: true
      }
    });
  }

  mapAdjectives = (adjective) => (
    <AdjectiveRow
      onChange={this.props.onChange}
      state={this.props.state}
      key={adjective.id}
      {...adjective}
      real={resolve(this.props, `responses/${adjective.id}/real`, false)}
      ideal={resolve(this.props, `responses/${adjective.id}/ideal`, false)}
      showModal={this.showModal}
      referenceReal={this.firstReal}
      referenceIdeal={this.firstIdeal}
    />
  );

  closeCurrentModal = () => {
    const { showModal } = this.state;
    showModal[this.props.state] = false;
    this.setState({
      showModal: showModal,
      modalShown: true
    });
    this.props.state == 'real' ? this.firstReal.current.focus()  : this.firstIdeal.current.focus();
  }

  onComplete = async () => {
    this.setState({
      saving: true
    });
    await this.props.onComplete();
    this.setState({
      saving: false,
      modalShown: true
    });
  }

  render() {
    const {
      adjectives=[],
      state,
      onComplete=()=>{}
    } = this.props;

    const {
      showModal,
      saving,
      modalShown
    } = this.state;

    const adj = [...adjectives];
    adj[0][`first`] = true;

    return (
      <div ref={this.ref} className="survey-version-list">
        {
          state === 'real'
            ? (
              <RealInstructions
                onClose={this.closeCurrentModal}
                active={!modalShown}
              />
            )
            : null
        }
        {
          state === 'ideal'
            ? (
              <IdealInstructions
                onComplete={onComplete}
                onClose={this.closeCurrentModal}
                active={showModal.ideal}
              />
            )
            : null
        }
        { adj.map(this.mapAdjectives) }
        <p style={{textAlign: 'right'}}>
          <SavingButton
            component="a"
            href="javascript:void(0)"
            className="button"
            saving={saving}
            onClick={onComplete}
            aria-label={state == 'ideal'? submitButtonSurvey : nextButtonSurvey}
          >
            {state == 'ideal' ? 'Submit' : 'Next'}
          </SavingButton>
        </p>
      </div>
    );
  }
}

export default ListVersion;
